export const hasRole = (role: string) => {
  let roles;
  try {
    const storedRoles = localStorage.getItem("tam_user_role");
    roles = storedRoles ? JSON.parse(storedRoles) : [];
  } catch (error) {
    roles = []; // Fallback to an empty array
  }

  return Array.isArray(roles) && roles.includes(role);
};
